class UserSettings
  constructor: ->
    $(document).on 'click', '.edit-control', (e) -> onEditControlClick(e)

    if $('#user_type_form input:checked').val() == "3"
      $('#user_age_groups').hide()
      $('#user_age_groups_form').hide()
    ###
    Submit forms when values change.
    TODO: extract this to a ui component.
    ###

    # Record current user type
    prev = $('#user_type_form input:checked').val()

    $(document).on 'change', '#user_type_form [data-update-on-change]', (e) ->
      type_complete = false
      $el = $(@)
      curr = $('#user_type_form input:checked').val()

      # if changing from other, set as complete. If necessary, we'll set a
      # student level on the server-side
      if prev == "3" && curr != "3"
        type_complete = true

      if $('#user_type_form input:checked').length
        type_complete = true

      if type_complete
        $.ajax
          type: 'patch'
          data: $el.serialize()
          dataType: 'script'
          url: $el.attr('action')
        prev = curr
      else
        alert 'At least one user type must be checked'
        $(e.target).prop('checked', true)

    $(document).on 'change', '#user_interests_form [data-update-on-change]', (e) ->
      interests_complete = false
      $el = $(@)

      if $('.user_interests input:checked').length
        interests_complete = true

      if interests_complete
        $.ajax
          type: 'patch'
          data: $el.serialize()
          dataType: 'script'
          url: $el.attr('action')
      else
        alert 'At least one interest must be selected'
        $(e.target).prop('checked', true)

    $(document).on 'change', '#user_age_groups_form [data-update-on-change]', (e) ->
      student_levels_complete = false
      $el = $(@)

      user_type = $('#user_type_form input:checked').val()
      if user_type == "3"
        student_levels_complete = true # other doesn't require student level

      if user_type != "3" &&
         $('.user_student_levels input:checked:not([disabled])').length
        student_levels_complete = true

      if student_levels_complete
        $.ajax
          type: 'patch'
          data: $el.serialize()
          dataType: 'script'
          url: $el.attr('action')
      else
        alert 'At least one grade level must be selected'
        $(e.target).prop('checked', true)

    $(document).on 'change', '#email_notifications [data-update-on-change]', (e) ->
      $el = $(@)
      $.ajax
        type: 'patch'
        data: $el.serialize()
        dataType: 'script'
        url: $el.attr('action')

  onEditControlClick = (e) ->
    e.preventDefault()
    $el = $(e.currentTarget)

    $($el.data('show-target')).show()
    $($el.data('hide-target')).hide()

$(document).on 'turbo:load', ->
  new UserSettings if $(document.body).hasClass 'usersSettingsView'
